<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="active"
      style="background:transparent"
    >
      <!-- Payroll -->
      <v-tab-item>
        <v-autocomplete
          v-model="payrollReport"
          label="Report Types"
          :items="payrollReportTypes"
          item-text="name"
          class="pt-5 px-3"
          autofocus
          style="background:white"
        />
        <payroll-report-c-p-2-2
          v-if="payrollReport === 'CP22'"
          class="mb-2"
        />
        <payroll-report-c-p-2-2-a
          v-if="payrollReport === 'CP22A'"
          class="mb-2"
        />        
        <payroll-report-income-tax-detail
          v-if="payrollReport === 'CP8D'"
          class="mb-2"
        />        
        <payroll-report-form-e-excel
          v-if="payrollReport === 'Form E Data'"
          class="mb-2"
        />
        <payroll-report-p-c-b2
          v-if="payrollReport === 'PCB(II)'"
          class="mb-2"
        />
        <payroll-report-ea-form
          v-if="payrollReport === 'EA Form'"
          class="mb-2"
        />
        <payroll-report-lampiran-b
          v-if="payrollReport === 'Lampiran B'"
          class="mb-2"
        />
        <payroll-report-epf
          v-if="payrollReport === 'Employee EPF Reports'"
          class="mb-2"
        />
        <payroll-report-previous-remuneration
          v-if="payrollReport === 'Previous Remuneration YTD (TP3) Reports'"
          class="mb-2"
        />        
      </v-tab-item>  

      <!-- PCB Statement -->
      <v-tab-item
        class="mt-1"
        style="background:white"
      >    
        <pcb-statement-container-view />
      </v-tab-item>

      <!-- PCB Arrear -->
      <v-tab-item
        class="mt-1"
        style="background:white"
      >   
        <pcb-arrear-container-view />
      </v-tab-item>
    </v-tabs-items>
    <!-- -->
  </div>
</template>

<script>
  export default {
    components: {
      PayrollReportCP22: () => import('@/components/hris/payroll/report/CP22'),
      PayrollReportCP22A: () => import('@/components/hris/payroll/report/CP22A'),      
      PayrollReportIncomeTaxDetail: () => import('@/components/hris/payroll/report/IncomeTaxDetail'),
      PayrollReportFormEExcel: () => import('@/components/hris/payroll/report/FormEExcel'),
      PayrollReportPCB2: () => import('@/components/hris/payroll/report/PCB2'),
      PayrollReportEaForm: () => import('@/components/hris/payroll/report/EaForm'),
      PayrollReportLampiranB: () => import('@/components/hris/payroll/report/LampiranB'),
      PayrollReportEpf: () => import('@/components/hris/payroll/report/Epf'),
      PayrollReportPreviousRemuneration: () => import('@/components/hris/payroll/report/PreviousRemuneration'),

      PcbArrearContainerView: () => import('@/components/hris/payroll/pcb-two/PcbArrearContainerView'),
      PcbStatementContainerView: () => import('@/components/hris/payroll/pcb-two/PcbStatementContainerView'),      
    },

    data () {
      return {
        tabItems: this.$hasPermissionTo(['view payroll pcb2']) ? [
          { name: 'Income Tax Reports' },
          { name: 'PCB Statement' },
          { name: 'PCB Arrear' },
        ] : [
          { name: 'Income Tax Reports' },
        ],
        active: 0,

        payrollReport: null,
        payrollReportTypes: [
          { name: 'CP22' },
          { name: 'CP22A' },
          { name: 'CP8D' },          
          { name: 'Form E Data' },
          { name: 'PCB(II)' },
          { name: 'EA Form' },
          { name: 'Lampiran B' },
          // { name: 'Employee EPF Reports' },
          { name: 'Previous Remuneration YTD (TP3) Reports' },          
        ],
      }
    },
  }
</script>
